import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    content: {
      '& .MuiTable-root': {
        '& .MuiTableCell-root:first-child': {
          paddingLeft: 16,
        },
      },
    },
    advisorDetails: {
      padding: 10,
      gap: '20px',
      minWidth: 600,
      minHeight: 200,

      '& .MuiInputBase-root': {
        background: 'transparent',
        pointerEvents: 'none',
      },

      '& .MuiFilledInput-input': {
        padding: '26px 12px 2px',
        fontSize: 12,
      },
    },

    inputHighlight: {
      '& .MuiFormLabel-root': {
        color: palette.primary.main,
      },

      '& .MuiInputBase-root': {
        color: palette.primary.main,
      },

      '& fieldset': {
        borderColor: palette.primary.main,
      },
    },

    contentDetails: {
      marginTop: 16,
    },

    colTitle: {
      margin: '8px 0',
      textAlign: 'center',
    },

    colSuggested: {
      backgroundColor: palette.superLightGray,
      borderRadius: 8,
      border: `1px solid ${palette.lightGray}`,
    },

    buttonsBase: {
      borderTop: `1px solid ${palette.borderGray}`,
      justifyContent: 'right',
      paddingTop: 10,
    },
    buttonsAlign: {
      justifyContent: 'flex-end',
      display: 'flex',
      paddingBottom: 10,
    },
    container: {
      '& .MuiOutlinedInput-root': {
        height: 45,
        width: 400,
      },

      '& .MuiGrid-container': {
        alignItems: 'center',
      },
    },
    containerTitle: {
      alignItems: 'center',
      marginLeft: 10,
      '& .MuiOutlinedInput-root': {
        height: 45,
        width: 400,
      },

      '& .MuiGrid-container': {
        alignItems: 'center',
      },
    },
    form: {
      paddingBottom: 10,
    },
    numberField: {
      textAlign: 'center',
      color: palette.darkGray,
    },
    personIconGray: {
      color: palette.darkGray,
      width: 40,
      height: 40,
    },
    cardTitles: {
      paddingRight: 7,
      fontSize: 14,
      display: 'flex',
      alignItems: 'center',
    },
    cardName: {
      paddingLeft: 7,
      fontWeight: 500,
      fontSize: 18,
      color: palette.blue,
      cursor: 'pointer',
    },
    cardInfos: { paddingTop: 10, paddingLeft: 10 },
    cardContent: { alignItems: 'baseline !important' },
    responsiveGrid: {
      display: 'flex',
      alignItems: 'baseline',
    },
    cardValues: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: 14,
      fontWeight: 500,
    },
    header: {
      boxShadow: '0 2px 4px 0 rgb(0 0 0 / 40%)',
      borderRadius: 8,
      padding: 10,
    },
    behaviorBorder: {
      border: `1px solid ${palette.sideGray}`,
      borderRadius: 8,
      padding: 15,
    },
    behaviorTitle: { fontSize: 16, color: palette.darkGray, fontWeight: 500 },
    accessButton: {
      fontSize: 15,
      color: palette.blue,
    },
    headerIcons: {
      display: 'flex',
      alignItems: 'center',
    },
    advisorTypeExplanations: {
      '& .MuiTypography-root': {
        fontSize: 14,
      },
    },
    advisorTypeExplanationGrid: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '8px',
    },
    advisorTypeExplanationText: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '8px',
    },
    advisorType: {
      fontWeight: 600,
      whiteSpace: 'nowrap',
    },
    boldText: { fontSize: 14, fontWeight: 600, whiteSpace: 'nowrap' },
    advisorTypeExplanationButton: {
      borderColor: palette.blue,
      color: palette.blue,
      height: 32,
      marginLeft: 16,
    },
    longNameField: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      maxWidth: 200,
      padding: '0 16px',
      color: palette.darkGray,
    },
    refreshButton: { padding: 0, margin: '0px 0px 0px 12px' },
    lowImpact: {
      color: palette.dashGreen,
      fontSize: 13,
      marginRight: 2,
      transform: 'rotate(90deg)',
    },
    mediumImpact: { color: palette.dashYellow, fontSize: 13, marginRight: 2 },
    highImpact: {
      color: palette.dashRed,
      fontSize: 13,
      transform: 'rotate(270deg)',
      marginRight: 2,
    },
    impactGrid: { display: 'flex', alignItems: 'center' },

    cardsTitle: {
      fontSize: 14,
      color: palette.darkGray,
      marginBottom: 4,
      fontWeight: 550,
    },
    dashboardHeader: { marginTop: 16 },
    dashboardButtonsHeader: {
      color: palette.blue,
      padding: '4px 8px!important',
      '&:hover': {
        backgroundColor: palette.superLightDeepBlue,
      },
    },
  });

export const overrideSearchbar = {
  search: {
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    padding: '5px 15px',
    width: '100%',
  },
};
